var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWifi = function SvgWifi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.742 16.743c7.32-7.322 19.194-7.326 26.569.002a1.25 1.25 0 0 0 1.762-1.773c-8.346-8.294-21.799-8.299-30.099.003a1.25 1.25 0 1 0 1.768 1.768"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20 17.916a12.08 12.08 0 0 0-8.544 3.54 1.25 1.25 0 0 1-1.768-1.768 14.583 14.583 0 0 1 20.624 0 1.25 1.25 0 0 1-1.768 1.767A12.08 12.08 0 0 0 20 17.916"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.17 26.17a5.417 5.417 0 0 1 7.66 0 1.25 1.25 0 0 0 1.767-1.767 7.917 7.917 0 0 0-11.194 0 1.25 1.25 0 0 0 1.767 1.768M20 28.75a1.25 1.25 0 1 0 0 2.5h.017a1.25 1.25 0 0 0 0-2.5z"
  })));
};
export default SvgWifi;